export const API_SERVER_URL = "https://api.redandblue.kr:8050/rnbmall-0.0.1";
// export const API_SERVER_URL = "http://192.168.0.59:8080";